import { AxiosRepo } from '@/helpers/interceptorsSetup';
import { CONSTANTS } from '@/constants/guide';
import router from '@/modules/router/config';
import { getCookie, setCookie } from '@/helpers/userHelper';

const axiosInstance = AxiosRepo.getInstance();

export const actions = {
  logIn({ dispatch, commit, state }, credentials) {
    commit('startLoading');
    return axiosInstance
      .post(`/ivs`, {
        ...credentials,
        Method: CONSTANTS.API.METHODS.LOG_IN
      })
      .then(response => {
        setCookie(
          response.cookieName,
          response.cookie,
          {
            domain: `.${window.location.hostname}`
          }
        );
        setCookie('PHPSESSID', response.cookie, {
          domain: `.${window.location.hostname}`
        });
        const responseData = response;
        commit('logIn', {
          meta: {
            lang: "de"
          },
          identity: {
            role: responseData.role,
            token: responseData.token,
            firstname: responseData.firstname,
            lastname: responseData.lastname,
            prefix: responseData.prefix,
            fullname: responseData.fullname,
            email: responseData.email,
            id: responseData.customerId,
            vetId: responseData.vetId,
            accountId: responseData.accountId,
            isRBPartner: responseData.isRBPartner
          }
        });

        if (state.landingPage.referer) {
          window.location.href = state.landingPage.referer;
        } else {
          const to = {
            path: state.landingPage.path,
            params: state.landingPage.params
          };
          commit('setLandingPage', { path: '/', params: {} });
          router.push(to);
        }
      });
  },
  forgotPassword({ commit }, form) {
    return axiosInstance
      .post(`/cb/customer/forgotPassword`, form)
      .then(response => {
        return response;
      })
      .catch(reason => {
        console.log(reason);
      });
  }
};
